const STORE_KEY = 'THIEVES'

export const FETCH_THIEVES = `${STORE_KEY}/FETCH_THIEVES`
